
import url from 'url';
import UrlPattern from 'url-pattern';

/**
 * 获取路由动态id 如：/tantu/webapp/routes/:id  -> id
 * @param {*} pattern 路由规则  /tantu/webapp/routes/:id
 * @param {*} path 验证的路由 /tantu/webapp/routes/15
 * @returns {id: 15}
 */
export function getRouterParamsId(
  pattern,
  path = window.location.pathname || url.parse(window.location.href).pathname
) {
  const _pattern = new UrlPattern(pattern);
  return _pattern.match(path);
}

export default url;
